// src/components/TransitionContainer.tsx 또는 적절한 위치에 생성
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const TransitionContainer = styled.div`
  opacity: 0; /* Initial state for fade-in */
  animation: ${fadeIn} 0.8s ease-in-out forwards; /* Apply fade-in animation */
  width: 100%;
  height: 100%;
`;